import { User } from 'types';
import { handleMutation } from 'hooks';
import { Flex } from 'components/flex';
import { Dialog } from 'components/dialog';
import { formatPrice } from 'utils/helpers';
import { useLookupQuery } from 'store/api/deal';
import { CartItem } from 'components/cart-item';
import { useRemoveDealMutation } from 'store/api/cart';
import { CartItem as CartItemType } from 'store/api/cart/types';

import * as Styles from './styles';

export interface CartDealGroupProps {
  dealId: number;
  eventId: number;
  authUser?: User;
  items: CartItemType[];
  hideDeleteCart?: boolean;
  hasCreditPayment?: boolean;
}

// POS Deals (owner, 26 Oct 2026): a deal's lines in the cart, under one
// "Deal: <name>" caption with its total and one Remove deal. The lines show as
// today's cart items without their own Delete. The name comes from the deals
// lookup (deleted deals too), so a deal that ended mid-cart keeps its name.
export const CartDealGroup = ({
  items,
  dealId,
  eventId,
  authUser,
  hideDeleteCart,
  hasCreditPayment,
}: CartDealGroupProps) => {
  const { data: names = [] } = useLookupQuery([dealId]);
  const [removeDeal, mutation] = useRemoveDealMutation();

  handleMutation(mutation);

  const total = items.reduce(
    (sum, item) => sum + Number(item.price) * Number(item.quantity),
    0
  );
  const label = names.find((deal) => deal.id === dealId)?.name || 'Deal';

  return (
    <Styles.Group>
      <Flex gap={8} alignItems="center" justifyContent="space-between">
        <Flex flexDirection="column">
          <p className="semibold">Deal: {label}</p>
          <Styles.Total>{formatPrice(total)}</Styles.Total>
        </Flex>
        {!hideDeleteCart && (
          <Dialog
            title="Remove deal"
            trigger={
              <Styles.StyledRemoveButton
                disabled={hasCreditPayment || mutation.isLoading}
              />
            }
            onConfirm={() => {
              console.log('[CART] remove deal', {
                dealId,
                userId: authUser?.id,
              });
              removeDeal({ dealId, id: eventId });
            }}
            text={
              <>
                You are going to remove the deal{' '}
                <span className="semibold">{label}</span> and all its products.
                Are you sure you want to do that?
              </>
            }
          />
        )}
      </Flex>
      {items.map((item) => (
        <CartItem
          value={item}
          key={item.id}
          hideDeleteCart
          authUser={authUser}
        />
      ))}
    </Styles.Group>
  );
};
